import { Navigate, Route, Routes } from 'react-router-dom';

import { useLogout } from 'common/auth';
import { NotFound } from 'common/components';

import DashboardLayout from './components/DashboardLayout';
import Dashboard from './features/dashboard';
import Profile from './features/profile';
import { DASHBOARD_ROUTES } from './routes';
import OverdueDashboard from './features/overdueDashboard';
import BulkUpload from './features/bulkUpload';
import FeesDashboard from './features/feesdashboard/filter';

const DashboardContainer = () => {
  // const { userId } = useAuth();

  const logout = useLogout();

  // const userPro = useFetchUser(userId);

  // let user: User = {
  //   id: '',
  //   isConfirmed: false,
  //   email: '',
  //   Username: '',
  // };

  // userPro.then((result) => {
  //   user.email = result.user.email;
  //   user.id = result.user.id;
  //   user.isConfirmed = result.user.isConfirmed;
  // });

  // if (user.email !== '') {
  //   return <LoadingScreen fullVPHeight />;
  // }

  return (
    <Routes>
      <Route element={<DashboardLayout email={'a'} logout={logout} />}>
        <Route index element={<Navigate replace to={DASHBOARD_ROUTES.home.to} />} />
        <Route path={DASHBOARD_ROUTES.dashboard.path} element={<Dashboard />} />
        <Route path={DASHBOARD_ROUTES.overdueDashboard.path} element={<OverdueDashboard />} />
        <Route path={DASHBOARD_ROUTES.bulkUpload.path} element={<BulkUpload />} />
        <Route path={DASHBOARD_ROUTES.profile.path} element={<Profile />} />
        <Route
          path={DASHBOARD_ROUTES.feesDashboard.path}
          element={
            <FeesDashboard
              isLoading={false}
              onSubmit={function (): Promise<void> {
                throw new Error('Function not implemented.');
              }}
            />
          }
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default DashboardContainer;
